import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { DemanderSignature } from '../model/demande-signature/demander-signature';
import { DemandeSignature } from '../model/demande-signature/demande-signature';

@Injectable({
    providedIn: 'root'
  })
  export class DemandeSignatureService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    findAllByRequest(requestId) {
        return this._restClientService.load<DemandeSignature[]>('demande-signature/find-all-by-request/'+requestId);
    }
    
    add(demanderSignature: DemanderSignature) {
        return this._restClientService.save<void>('demande-signature/create', demanderSignature);
    }
  
  }